import React from 'react';

import {
    DiscoveryUnit,
    DiscoveryUnitItem,
    PAGE_TYPE_SUBS_LOGGED_IN_HOMEPAGE,
} from '@udemy/discovery-api';
import {DeviceType} from '@udemy/hooks';
import {useI18n} from '@udemy/i18n';
import {DiscoveryUnitsContainer} from '@udemy/react-discovery-units';

// TODO: LabUnit exists only in Django monolith
// It's not yet migrated to any frontend packages
const LabUnit = () => {
    return (
        <div style={{padding: '20px', border: '1px dashed #ccc', textAlign: 'center'}}>
            Lab Unit Placeholder
        </div>
    );
};

interface LabsDiscoveryUnitProps {
    enableLabsInPersonalPlan: boolean;
    isTechLearner: boolean;
    deviceType: DeviceType;
    className?: string;
}

export const LabsDiscoveryUnit: React.FC<LabsDiscoveryUnitProps> = ({
    enableLabsInPersonalPlan,
    isTechLearner,
    deviceType,
    className = 'component-margin',
}) => {
    const {gettext} = useI18n();
    if (!enableLabsInPersonalPlan || !isTechLearner) {
        return null;
    }

    const getUnitComponentAndProps = (
        unit: Partial<DiscoveryUnit<DiscoveryUnitItem>> | undefined,
    ) => {
        if (!unit) throw new Error('Missing unit');

        return {
            component: LabUnit,
            componentProps: {
                title: gettext('Practice with hands-on labs'),
                subtitle: gettext('Apply your skills in real-world scenarios'),
                uiRegion: 'LABS_UNIT_LIHP',
                isStandaloneUnit: true,
            },
        };
    };

    return (
        <div className={className} data-purpose="labs-unit-container">
            <DiscoveryUnitsContainer
                pageType={PAGE_TYPE_SUBS_LOGGED_IN_HOMEPAGE}
                deviceType={deviceType}
                getUnitComponentAndProps={getUnitComponentAndProps}
                filter={(u) => u.type === 'algorithm_based_labs'}
                disableInfiniteScroll={true}
                fetchOptions={{pageSize: 3}}
            />
        </div>
    );
};
